import { FC } from 'react'

interface IconProps {
  width?: number
  height?: number
  fill?: string
  stroke?: string
  strokeWidth?: number
}
/** Creates SVG element for interactions view icon
 * @param {number} width icon width in px
 * @param {number} height icon height in px
 * @param {string} fill icon fill color
 * @param {string} stroke icon stroke color
 * @param {number} strokeWidth icon stroke width
 * */
export const InteractionsIcon: FC<IconProps> = ({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}) => {
  return (
    // IconChartDots3 - Tabler Icons
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className='icon icon-tabler icons-tabler-outline icon-tabler-chart-dots-3'
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M5 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
      <path d='M16 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
      <path d='M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
      <path d='M6 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
      <path d='M9 17l5 -1.5' />
      <path d='M6.5 8.5l7.81 5.37' />
      <path d='M7 7l8 -1' />
    </svg>
  )
}
